import { ButtonProps } from "../../types/types";

const Button: React.FC<ButtonProps> = ({ children, className = "", loading, ...props }) => {
	return (
		<button className={`relative bg-dark hover:bg-dark/90 text-white h-11 2xl:h-[56px] rounded-xl text-center w-full text-base xl:text-lg font-semibold ${className}`} {...props}>
			{loading ? (
				<span className="flex h-5 w-full items-center justify-center">
					<div className="animate-spin rounded-full h-6 w-6 border-t-2 border-white border-solid border-b-transparent"></div>
				</span>
			) : (
				children
			)}
		</button>
	);
};

export default Button;
